import React, {useState} from 'react';
import Modal, { useModal } from '../../Components/Modal';
import { useBalance, useLeadBundles } from '../../Data/Balance';
import { PageLoading } from '../../Components/Loading';
import Money from '../../Components/Formatting/Money';
import { numFormat } from '../../Services/helpers';
import Button from '../../Components/Button/Button';
import CustomSelect from '../../Components/Containers/CustomSelect';
import ButtonRow from '../../Components/Button/ButtonRow';

const AddLeadCredits = ({isOpen, setIsOpen, onComplete}) => {
    return <Modal isOpen={isOpen} setIsOpen={setIsOpen} title="Top up lead credits" dismissible>
        {isOpen && <Inner {...{onComplete}} />}
    </Modal>
}

const Inner = ({onComplete}) => {
    const {closeModal} = useModal();
    const {bundles} = useLeadBundles();
    const {balance, purchaseLeadCredits, isSaving} = useBalance();
    const [selected, setSelected] = useState(null);

    if (!bundles || !balance) {
        return <PageLoading />;
    }

    const handlePurchase = async () => {
        await purchaseLeadCredits(selected);
        onComplete && onComplete();
        closeModal();
    }

    return <>
        <p className="mb-4">
            You currently have {numFormat(balance.leadCredits)} lead credits.
        </p>

        <CustomSelect
            isDisabled={isSaving}
            onChange={setSelected}
            options={bundles.map(bundle => ({
                value: bundle.count,
                body: <div className="grid grid-cols-2 items-center">
                    <div className="text-lg text-brand font-bold">
                        {numFormat(bundle.count)} Credits
                    </div>
                    <div className="leading-4">
                        <Money pence={bundle.cost} /><br />
                        {bundle.save > 0 && <span className="text-muted text-sm">
                            Save <Money pence={bundle.save} />
                        </span>}
                    </div>
                </div>
            }))}
        />
        <ButtonRow>
            <Button theme="secondary" label="Cancel" onClick={() => closeModal()} disabled={isSaving} />
            <Button theme="primary" label="Add" onClick={() => handlePurchase()} loading={isSaving} />
        </ButtonRow>
    </>

}

export default AddLeadCredits;
